import Vue from 'vue'
import App from './App.vue'
import ZainComponentLibrary from './zain-component-library/src/entry.esm'
import './assets/styles.css'
import router from './router'
import './vee-validate'
import store from './store'
import i18n from '@/i18n'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

Vue.use(Buefy)
Vue.use(ZainComponentLibrary)
Vue.config.productionTip = false

new Vue({
  render: (h) => h(App),
  router,
  store,
  i18n
}).$mount('#app')
